import { createAction, props } from '@ngrx/store';

export const SetDashboardProducts = '[SetDashboardProducts] set products';
export const SetProductsReloadRequired = '[SetProductsReloadRequired] set products reload required';



export const setDashboardProducts = createAction(
    SetDashboardProducts,
    props<{
        limit: number;
        totalItems: number;
        products: Array<any>;
    }>()
);

export const setProductsReloadRequired = createAction(
    SetProductsReloadRequired,
    props<{
        reloadRequired: boolean
    }>()
);


